<template>
    <div class="newGood">
        <ul class="fix">
            <li v-for="(item,index) in list" :key="index" @click="handleClick(index)">
                <div class="imgBox">
                        <el-image style="width: 100%;height: 100%"
                                  :src="item.CoverPic">
                            <div slot="placeholder" class="image-slot">
                                加载中<span class="dot">...</span>
                            </div>
                            <div slot="error" class="el-image__error">
                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                            </div>
                        </el-image>
                    <strong class="title fontSong12">{{item.WorkName}}</strong>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "newGood",
    props: ["list"],
    data(){
        return{
            dataList:[{},{},{},{},{}],
            webName: ''
        }
    },
    mounted(){
        this.webName = this.$router.history.current.params.name;
    },
    methods: {
        handleClick(i) {
            this.$router.push(`/${this.webName}/collect?id=3&index=${i}`)
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.newGood{
    ul{
        li{
            float: left;
            margin-right: 10px;
            margin-bottom: 10px;
            width: calc(50% - 5px);
            //height: 90px;
            overflow: hidden;
            cursor: pointer;
            &:nth-child(2n){
                margin-right: 0;
            }
            .imgBox{
                // width: 165px;
                height: 120px;
                position: relative;
                .title{
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    display: block;
                    color: #fff;
                    background: rgba(0,0,0,.5);
                    height: 20px;
                    line-height: 20px;
                    text-align: center;
                }
            }
        }
    }
}
</style>